import { infoResendMessage } from './createResendInfoBarMessage.locstring.json';
import { infoLinkClickHere } from 'owa-locstrings/lib/strings/infolinkclickhere.locstring.json';
import loc from 'owa-localize';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { isNDRItem } from 'owa-mail-reading-pane-item-actions/lib/utils/checkItemType';
import { lazyTryCreateResendDraft } from 'owa-mail-compose-actions';
import Message from 'owa-service/lib/contract/Message';

import {
    InfoBarCustomAction,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

export default function tryCreateResendInfoBarMessage(
    message: Message,
    key: string,
    viewState: ItemViewState
): InfoBarMessageViewState {
    if (canResend(message)) {
        const resendAction: InfoBarCustomAction = {
            action: () => {
                lazyTryCreateResendDraft.importAndExecute(message.ItemId.Id, viewState);
            },
            text: loc(infoLinkClickHere),
        };

        return <InfoBarMessageViewState>{
            key: key,
            source: InfoBarMessageSource.ReadingPane,
            rank: InfoBarMessageRank.Info,
            messageParts: [loc(infoResendMessage), resendAction],
        };
    }

    return null;
}

function canResend(message: Message): boolean {
    return isNDRItem(message) && message.Attachments && message.Attachments.length == 1;
}
